import { render, staticRenderFns } from "./AlmostExpiredDrugs.vue?vue&type=template&id=1b4ca934&scoped=true"
import script from "./AlmostExpiredDrugs.vue?vue&type=script&lang=js"
export * from "./AlmostExpiredDrugs.vue?vue&type=script&lang=js"
import style0 from "./AlmostExpiredDrugs.vue?vue&type=style&index=0&id=1b4ca934&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ca934",
  null
  
)

export default component.exports